import { List, ListItem, ListItemIcon, ListItemText } from 'beam'
import BeamIcon from 'beam/dist/BeamIcon'
import { FC, useContext } from 'react'
import { FormContext, Section } from './FormContext'

// Allows the user to scroll to the section they click on
const createScrollToSectionHandler = ({ ref }: Section) => () => {
  if (ref.current) {
    ref.current.scrollIntoView()
  }
}

const Sidebar: FC = () => {
  const formContext = useContext(FormContext)

  return (
    <div>
      <List disablePadding={true} component="nav" data-testid="AdminFormSidebar-List">
        {/* The sections registered to the parent <Form> will be displayed in the sidebar as a list */}
        {formContext.sections.map(section => (
          !section.isSubSection &&
          <ListItem button key={section.sectionId} selected={section.isActive} onClick={createScrollToSectionHandler(section)}>
            {section.isValid && (
              <ListItemIcon>
                <BeamIcon>Check</BeamIcon>
              </ListItemIcon>
            )}
            <ListItemText inset={!section.isValid} primary={section.title} />
          </ListItem>
        ))}
      </List>
    </div>
  )
}

export default Sidebar
